import { Box, Header } from '@rbilabs/universal-components';

export const Heading = Box.withConfig({
  paddingTop: {
    md: 5,
  },
});

export const CartErrorHeading = Header.withConfig({
  variant: 'hero',
  lineHeight: 'xs',
  textAlign: 'center',
  margin: 0,
  marginTop: '$8',
});
